import { Component, OnInit } from "@angular/core";
import { IoptionElemet } from "@ispm/shared/interfaces/IoptionElemet";
import { Observable, Subject } from "rxjs";

@Component({
    selector: 'gen-aberration-extra-modal',
    templateUrl: './aberration-extra-modal.component.html',
})

export class AberrationExtraModalComponent implements OnInit {

    public payload: { formName: string, options: IoptionElemet[] };
    public tunnel$: Subject<any>;
    public callback: (modal) => Observable<Response>;
    public modalPayload: any;
    public modal: any;

    ngOnInit() {
        this.tunnel$
          .asObservable()
          .filter(value => value.emitter !== 'child')
          .subscribe(next => {
            this.callback(this.modal);
            this.tunnel$.next({ emitter: 'children', value: 1});
            next.value;
          });
        this.modalPayload = this.payload['modalPayload'];
    }

    public noteChanged($event) {
        this.modal = {};
        this.modal.currentAberration = $event.currentAberration;
        this.modal.isNoteChanged = true;
        this.callback(this.modal);
    }

    public selectionChanged($event) {
        this.modal = {};
        this.modal.currentAberration = $event.currentAberration;
        this.modal.selectionState = $event.selectionState;
        this.modal.isSelectionChanged = true;
        this.callback(this.modal);
    }
}
